import React from "react"

import SpecialTreatmentControl from "../SpecialTreatmentControl"

const WizardSpecialTreatmentStep = ({ options }) => {
  return <SpecialTreatmentControl options={options} optionType="checkbox" inline={false} className="" />
}

export default WizardSpecialTreatmentStep
